"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DropDownOption = ({ label, value, disabled, onClick }) => {
    const onClickOption = react_1.default.useCallback(() => onClick({ label, value, disabled }), [label, value, disabled]);
    return (react_1.default.createElement("div", { className: `ecr-dropdown-row ${disabled ? 'disabled' : ''}`, onClick: onClickOption, role: "presentation" },
        label,
        disabled ? ' *' : ''));
};
exports.default = DropDownOption;
//# sourceMappingURL=DropDownOption.js.map